import {agencyActions} from "../actionTypes";

import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `agenciesActions.js`);



/** ---------------- action creators ---------------- */
const getAgenciesRequest = () => ({
  type: agencyActions.GET_AGENCIES_REQUEST,
});


const removeAgencyRequest = (id) => ({
  type: agencyActions.DELETE_AGENCY_REQUEST,
  id,
});

const createAgencyRequest = (config) => ({
  type: agencyActions.POST_AGENCY_REQUEST,
  ...config,
});

const updateAgencyRequest = (id, config) => ({
  type: agencyActions.PUT_AGENCY_REQUEST,
  id,
  ...config,
});

/** ---------------- action sequences ---------------- */

const getAgencies = () => {
  return (dispatch) => {
    debug.enter(`getAgencies`);
    return dispatch(getAgenciesRequest());
  }
};

const removeAgency = (id) => {
  return (dispatch) => {
    debug.enter(`removeAgency`);
    return dispatch(removeAgencyRequest(id));
  }
};

const createAgency = (config) => {
  return (dispatch) => {
    debug.enter(`createAgency`);
    return dispatch(createAgencyRequest({
      ...config,
    }));
  };
};

const updateAgency = (id, title) => {
  return (dispatch) => {
    debug.enter(`updateAgency`);
    return dispatch(updateAgencyRequest(id, {
      ...title
    }));
  }
};


export {
  getAgencies,
  createAgency,
  updateAgency,
  removeAgency,
};



// WEBPACK FOOTER //
// ./src/data/agencies/agenciesActions.js